import React from 'react';

import { useAppSelector } from '../hooks/appHooks';
import { Package } from '../interfaces/Types';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { PlusPacketContainer } from './PlusPacketContainer';

export const AdditionalPackagesContainer = () => {
  const plusPacketList =
    useAppSelector((state) =>
      state.insurance.packages.filter((item: Package) => item.isPlusPackage)
    ) || {};
  return (
    <>
      {!InsuranceHelper.isEmptyObject(plusPacketList) && (
        <PlusPacketContainer plusPacketData={plusPacketList} />
      )}
    </>
  );
};
